<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert', null)"
                    v-if="pageMap.handle.insert && checkPermissionButton('新增')">新增</el-button>
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
                <el-upload :action="importUrl" :headers="{ 'auth-admin': adminToken, 'auth-company': companyToken }"
                    accept=".xlsx,.xls" :before-upload="beforeUpload" :on-success="onSuccess" :on-error="onError"
                    :show-file-list="false">
                    <el-button type="primary" style="margin: 0px 12px;" :loading="importLoading"
                        v-if="checkPermissionButton('导入Excel')">导入Excel</el-button>
                </el-upload>
                <el-button type="primary" @click="exportOpen()" v-if="checkPermissionButton('导出Excel')">导出Excel</el-button>
            </div>
            <div class="header-right" v-if="pageMap.filter">
                <el-date-picker v-model="monthRange" type="monthrange" format="yyyyMM" value-format="yyyyMM"
                    range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" style="margin-right: 10px;"
                    @change="monthRangeChange" clearable>
                </el-date-picker>
                <el-input v-for="item in pageMap.filter" v-model="filterParams[item.prop]"
                    :placeholder="'请输入' + item.label" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column prop="inventoryCommonMonth" label="月份" width="90"></el-table-column>
            <el-table-column prop="inventoryCustomerName" label="公司名称" width="300">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryCustomerName)">{{
                        scope.row.inventoryCustomerName }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="inventoryCustomerPerson" label="负责人">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryCustomerPerson)">{{
                        scope.row.inventoryCustomerPerson }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="inventoryCategoryName" label="项目">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryCategoryName)">{{
                        scope.row.inventoryCategoryName }}</span>
                </template>
            </el-table-column>
            <el-table-column label="贸易">
                <el-table-column prop="inventoryAccountPlanTradeAmount" label="贸易量">
                    <template slot-scope="scope">
                        <span class="td-copy" @click="copyClick(scope.row.inventoryAccountPlanTradeAmount)">{{
                        scope.row.inventoryAccountPlanTradeAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="inventoryCategoryPercentUp" label="费率">
                    <template slot-scope="scope">
                        <span class="td-copy" @click="copyClick(scope.row.inventoryCategoryPercentUp)">{{
                        scope.row.inventoryCategoryPercentUp }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="inventoryAccountPlanTradeFee" label="费用">
                    <template slot-scope="scope">
                        <span class="td-copy" @click="copyClick(scope.row.inventoryAccountPlanTradeFee)">{{
                        scope.row.inventoryAccountPlanTradeFee }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="过夜">
                <el-table-column prop="inventoryAccountPlanNightPercent" label="比例">
                    <template slot-scope="scope">
                        <span v-if="scope.row.inventoryAccountPlanNightPercent" class="td-copy"
                            @click="copyClick(scope.row.inventoryAccountPlanNightPercent)">{{
                        scope.row.inventoryAccountPlanNightPercent * 100 + "%" }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="inventoryAccountPlanNightRate" label="费率">
                    <template slot-scope="scope">
                        <span class="td-copy" @click="copyClick(scope.row.inventoryAccountPlanNightRate)">{{
                        scope.row.inventoryAccountPlanNightRate }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="inventoryAccountPlanNightFee" label="过夜费">
                    <template slot-scope="scope">
                        <span class="td-copy" @click="copyClick(scope.row.inventoryAccountPlanNightFee)">{{
                        scope.row.inventoryAccountPlanNightFee }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="利差">
                <el-table-column prop="inventoryAccountPlanProfitRate" label="比例">
                    <template slot-scope="scope">
                        <span class="td-copy" @click="copyClick(scope.row.inventoryAccountPlanProfitRate)">{{
                        scope.row.inventoryAccountPlanProfitRate }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="inventoryAccountPlanProfitFee" label="利差">
                    <template slot-scope="scope">
                        <span class="td-copy" @click="copyClick(scope.row.inventoryAccountPlanProfitFee)">{{
                        scope.row.inventoryAccountPlanProfitFee }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column prop="inventoryAccountPlanMemo" label="备注">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountPlanMemo)">{{
                        scope.row.inventoryAccountPlanMemo }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="inventoryAccountPlanServiceTotal" label="服务费">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountPlanServiceTotal)">{{
                        scope.row.inventoryAccountPlanServiceTotal }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="inventoryAccountPlanFeeTotal" label="合计">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountPlanFeeTotal)">{{
                        scope.row.inventoryAccountPlanFeeTotal }}</span>
                </template>
            </el-table-column>
            <!-- 操作栏 -->
            <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                    <div v-if="scope.row.inventoryCommonMonth != '合计'">
                        <el-button @click="copyPayment(scope.row)" type="text" size="small"
                            v-if="checkPermissionButton('复制')">复制</el-button>
                        <el-button @click="handleClick('update', scope.row)" type="text" size="small"
                            v-if="pageMap.handle.update && checkPermissionButton('编辑')">编辑</el-button>
                        <el-button @click="handleClick('delete', scope.row)" type="text" size="small"
                            v-if="pageMap.handle.delete && checkPermissionButton('删除')">删除</el-button>
                    </div>
                    <div v-else>-</div>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 1000]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="40%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="100px">
                    <!-- 基本信息 -->
                    <el-form-item label="选择客户">
                        <el-select v-model="handleInfo.inventoryCustomerId" placeholder="请选择" style="width: 100%;"
                            filterable>
                            <el-option v-for="option in customers" :label="option.inventoryCustomerName"
                                :value="option.inventoryCustomerId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="选择产品">
                        <el-select v-model="handleInfo.inventoryCategoryId" placeholder="请选择" style="width: 100%;"
                            filterable>
                            <el-option v-for="option in categories" :label="option.inventoryCategoryName"
                                :value="option.inventoryCategoryId"></el-option>
                        </el-select>
                        <div v-if="handleInfo.inventoryCategoryId" style="line-height: 14px; margin-top: 7px;">{{
                        getCategoryPercent() }}</div>
                    </el-form-item>
                    <el-form-item label="账单月份">
                        <el-date-picker v-model="handleInfo.inventoryCommonMonth" type="month" format="yyyyMM"
                            value-format="yyyyMM" style="width: 100%;">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="贸易量(元)">
                        <el-input v-model="handleInfo.inventoryAccountPlanTradeAmount"></el-input>
                    </el-form-item>
                    <el-form-item label="利差比例">
                        <el-input v-model="handleInfo.inventoryAccountPlanProfitRate"></el-input>
                    </el-form-item>
                    <el-form-item label="过夜比例">
                        <el-select v-model="handleInfo.inventoryAccountPlanNightPercent" placeholder="请选择"
                            style="width: 100%;">
                            <el-option v-for="option in nightPercents" :label="option.label"
                                :value="option.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="过夜费率">
                        <el-input v-model="handleInfo.inventoryAccountPlanNightRate"></el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input v-model="handleInfo.inventoryAccountPlanMemo"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 导出弹窗 -->
        <el-dialog title="选择导出设置" :visible.sync="isExport" width="30%">
            <el-checkbox-group v-model="exportChecked">
                <el-checkbox :label="item.name" v-for="item in exportMap"></el-checkbox>
            </el-checkbox-group>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isExport = false">取 消</el-button>
                <el-button type="primary" @click="exportConfirm()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"

import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin],
    data: function () {
        return {
            importUrl: "",
            adminToken: "",
            companyToken: "",
            type: "",
            customers: [],
            monthRange: [],
            importLoading: false,
            nightPercents: [
                {
                    label: "10%",
                    value: 0.1
                },
                {
                    label: "20%",
                    value: 0.2
                },
                {
                    label: "30%",
                    value: 0.3
                },
                {
                    label: "40%",
                    value: 0.4
                },
                {
                    label: "50%",
                    value: 0.5
                },
                {
                    label: "60%",
                    value: 0.6
                }
            ]
        }
    },
    methods: {
        copyPayment: async function (row) {
            this.$confirm("是否确认要复制当前消息？", "复制确认", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(async () => {
                let resultObj = await doGet(API.PAYMENT_COPY, { paymentId: row.inventoryPaymentId });
                this.showResult(resultObj);
            }).catch(() => {
            });
        },
        beforeUpload() {
            this.importLoading = true;
            return true;
        },
        // 请求成功回调
        onSuccess(res) {
            this.$message.success(res.errorMessage);
            this.initialData();
            this.importLoading = false;
        },
        // 请求失败回调
        onError(err) {
            this.$message.error("导入失败");
            this.importLoading = false;
        },
        monthRangeChange: function (e) {
            if (e) {
                this.filterParams.inventory_common_month_start = e[0];
                this.filterParams.inventory_common_month_end = e[1];
            }
            else {
                this.monthRange = [];
                this.filterParams.inventory_common_month_start = "";
                this.filterParams.inventory_common_month_end = "";
            }
            this.loadData(1);
        },
        getCategoryPercent: function () {
            if (this.handleInfo.inventoryCategoryId) {
                let retStr = "";
                for (let i = 0; i < this.categories.length; i++) {
                    if (this.categories[i].inventoryCategoryId == this.handleInfo.inventoryCategoryId) {
                        // retStr = "上游费率：" + this.categories[i].inventoryCategoryPercentUp + " | 下游费率：" + this.categories[i].inventoryCategoryPercentDown;
                        retStr = "上游费率：" + this.categories[i].inventoryCategoryPercentUp;
                        break;
                    }
                }
                return retStr;
            }
        },
        categoryChange: function (e) {
            this.handleInfo.inventoryCategoryName = this.handleInfo.inventoryCategoryId;
        },
        getSelectData: async function () {
            this.customers = await doGet("/inventoryCustomer" + API.ALL);
            this.categories = await doGet("/inventoryCategory" + API.ALL);
        },
        beforeHandleOpenEx: function (handle, info, type) {
            this.type = type;
            if (handle == "update") {
                this.handleInfo.inventoryCommonMonth = info.inventoryCommonMonth + "";
                this.handleInfo.type = type;
            }
            if (handle == "insert") {
                this.$set(this.handleInfo, "inventoryAccountPlanNightRate", "0");
                this.$forceUpdate();
            }
        },
        afterInitialData: function () {
            if (this.records && this.records.length > 0) {
                let inventoryAccountPlanTradeAmount = 0;
                let inventoryAccountPlanTradeFee = 0;
                let inventoryAccountPlanProfitFee = 0;
                let inventoryAccountPlanNightFee = 0;
                let inventoryAccountPlanServiceTotal = 0;
                let inventoryAccountPlanFeeTotal = 0;
                for (let i = 0; i < this.records.length; i++) {
                    inventoryAccountPlanTradeAmount += this.records[i].inventoryAccountPlanTradeAmount;
                    inventoryAccountPlanTradeFee += this.records[i].inventoryAccountPlanTradeFee;
                    inventoryAccountPlanProfitFee += this.records[i].inventoryAccountPlanProfitFee;
                    inventoryAccountPlanNightFee += this.records[i].inventoryAccountPlanNightFee;
                    inventoryAccountPlanServiceTotal += this.records[i].inventoryAccountPlanServiceTotal;
                    inventoryAccountPlanFeeTotal += this.records[i].inventoryAccountPlanFeeTotal;
                }
                this.records.push({
                    inventoryCommonMonth: '合计',
                    inventoryCustomerName: '-',
                    inventoryCustomerPerson: '-',
                    inventoryCategoryName: '-',
                    inventoryAccountPlanTradeAmount: inventoryAccountPlanTradeAmount.toFixed(1),
                    inventoryCategoryPercentUp: '-',
                    inventoryAccountPlanTradeFee: inventoryAccountPlanTradeFee.toFixed(1),
                    inventoryAccountPlanProfitRate: '-',
                    inventoryAccountPlanProfitFee: inventoryAccountPlanProfitFee.toFixed(1),
                    inventoryCommonNightPercent: '-',
                    inventoryCommonNightRate: '-',
                    inventoryAccountPlanNightFee: inventoryAccountPlanNightFee.toFixed(1),
                    inventoryAccountPlanMemo: '-',
                    inventoryAccountPlanServiceTotal: inventoryAccountPlanServiceTotal.toFixed(1),
                    inventoryAccountPlanFeeTotal: inventoryAccountPlanFeeTotal.toFixed(1)
                });
            }
        }
    },
    created: function () {
        this.tag = "inventoryPayment";
        this.getSelectData();
        this.importUrl = process.env.VUE_APP_BASE_API + "/inventoryPayment/importPlan";
        this.adminToken = localStorage.getItem("AUTH-ADMIN");
        this.companyToken = localStorage.getItem("AUTH-COMPANY");
        this.exportMap = [
            //COMMON
            { name: "月份", value: "inventoryCommonMonth", checked: true },
            { name: "公司名称", value: "inventoryCustomerName", checked: true },
            { name: "负责人", value: "inventoryCustomerPerson", checked: true },
            { name: "项目", value: "inventoryCategoryName", checked: true },
            //上游计划
            { name: "贸易：贸易量", value: "inventoryAccountPlanTradeAmount", checked: true },
            { name: "贸易：费率", value: "inventoryCategoryPercentUp", checked: true },
            { name: "贸易：费用", value: "inventoryAccountPlanTradeFee", checked: true },
            { name: "过夜：比例", value: "inventoryAccountPlanNightPercent", checked: true },
            { name: "过夜：费率", value: "inventoryAccountPlanNightRate", checked: true },
            { name: "过夜：过夜费", value: "inventoryAccountPlanNightFee", checked: true },
            { name: "利差：比例", value: "inventoryAccountPlanProfitRate", checked: true },
            { name: "利差：利差", value: "inventoryAccountPlanProfitFee", checked: true },
            { name: "备注", value: "inventoryAccountPlanMemo", checked: true },
            { name: "服务费", value: "inventoryAccountPlanServiceTotal", checked: true },
            { name: "合计", value: "inventoryAccountPlanFeeTotal", checked: true },
        ];
    },
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>